import { gql } from '@apollo/client';

/**
 * D21: the brand admin's ledger. `asReferrer` = owed to this brand (rows whose
 * `referringBrandSite` is this brand); `asCarOwner` = owed by this brand (rows
 * whose checkout `brandSite` is this brand). The platform owner may pass
 * `brandSite` to view another brand, or none to view every brand.
 */
export const GET_REFERRAL_COMMISSIONS = gql`
  query GetReferralCommissions($input: ReferralCommissionsInput) {
    referralCommissions(input: $input) {
      brandSite
      commissions {
        id
        bookingId
        status
        commissionAmount
        commissionBasis
        commissionRate
        currencyCode
        earnedAt
        voidedAt
        createdAt
        referringBrandSite
        brandSite
        carOwnerHost {
          id
          firstName
          lastName
          displayName
        }
        booking {
          id
          startAt
          endAt
          status
          car {
            id
            make
            model
            year
            thumbnailUrl
          }
        }
      }
      asReferrer {
        pendingAmount
        earnedAmount
        voidedAmount
        totalAmount
        currencyCode
      }
      asCarOwner {
        pendingAmount
        earnedAmount
        voidedAmount
        totalAmount
        currencyCode
      }
    }
  }
`;
